const quimangequiData = [
    {
        lang: 'fr',
        titre: 'Qui mange qui',
        intro: 'En chemin, faisons une pause pour comprendre la chaîne alimentaire dans la mer Méditerranée.',
        consigne: `Fais <class="bold">glisser</class> les images pour\nplacer <class="bold">les espèces</class> au bon endroit dans la chaîne alimentaire.`,
        questionConsigne: {
            singular: 'Qui est',
            plural: 'Qui sont',
        },
        consignes: [
            'le super-prédateur',
            'les gros carnivores',
            'les petits carnivores',
            'le plancton animal',
            'les herbivores',
            'le plancton végétal',
        ],
        buttonLabel1: 'Suivant',
        buttonLabel2: 'Valider',
        buttonLabel3: 'Entrer cette réponse',
        bonneReponseImage: 'bonne-rep-activite-1',
        mauvaiseReponseImage: 'mauvaise-rep-activite-1',
        bouteilleVideImage: 'bouteille-vide-activite-3',
        bouteilleFinaleImage: 'bouteille-finale-3',
        imagesSlider: [
            'slider-img-1-activite-3',
            'slider-img-2-activite-3',
            'slider-img-3-activite-3',
            'slider-img-4-activite-3',
            'slider-img-5-activite-3',
            'slider-img-6-activite-3',
        ],
        imagesChaineAlimentaire: [
            'chaine-img-1-activite-3',
            'chaine-arrow-1-activite-3',
            'chaine-img-2-activite-3',
            'chaine-arrow-2-activite-3',
            'chaine-img-3-activite-3',
            'chaine-arrow-3-activite-3',
            'chaine-img-4-activite-3',
            'chaine-arrow-4-activite-3',
            'chaine-img-5-activite-3',
            'chaine-arrow-5-activite-3',
            'chaine-img-6-activite-3',
        ],
        lettres: ['H', 'U', 'M', 'A', 'I', 'N'],
        lettresPositions: {
            center: [
                { x: 663, y: 330 },
                { x: 663 + 27, y: 330 },
                { x: 663 + 52, y: 330 },
                { x: 663 + 80, y: 330 },
                { x: 663 + 108, y: 330 },
                { x: 663 + 132, y: 330 },
            ],
            bottom: [
                { x: 1230, y: 580 },
                { x: 1230 + 22, y: 580 },
                { x: 1230 + 44, y: 580 },
                { x: 1230 + 68, y: 580 },
                { x: 1230 + 90, y: 580 },
                { x: 1230 + 112, y: 580 },
            ],
        },
        endTitre: 'Bravo !',
        endTexte: `Tu as retrouvé les lettres du mot :`,
        endTexte2: `C’est la menace principale pour l’équilibre de la chaîne alimentaire…`,
        videoKey: 'rorqualVideo',
    },
    {
        lang: 'en',
        titre: 'WHO EATS WHO',
        intro: 'Let’s take a break and learn who eats who in the sea!',
        consigne: `<class="bold">Drag</class> the animals to the right spots in the food chain.`,
        questionConsigne: {
            singular: 'Who is',
            plural: 'Who are',
        },
        consignes: [
            'the top predator',
            'the large carnivores',
            'the small carnivores',
            'the animal plankton',
            'the plant eaters',
            'the plant plankton',
        ],
        buttonLabel1: 'Next',
        buttonLabel2: 'Validate',
        buttonLabel3: 'Enter this answer',
        bonneReponseImage: 'bonne-rep-activite-1-en',
        mauvaiseReponseImage: 'mauvaise-rep-activite-1-en',
        bouteilleVideImage: 'bouteille-vide-activite-3',
        bouteilleFinaleImage: 'bouteille-finale-3-en',
        imagesSlider: [
            'slider-img-1-activite-3-en',
            'slider-img-2-activite-3-en',
            'slider-img-3-activite-3-en',
            'slider-img-4-activite-3-en',
            'slider-img-5-activite-3-en',
            'slider-img-6-activite-3-en',
        ],
        imagesChaineAlimentaire: [
            'chaine-img-1-activite-3-en',
            'chaine-arrow-1-activite-3',
            'chaine-img-2-activite-3-en',
            'chaine-arrow-2-activite-3',
            'chaine-img-3-activite-3-en',
            'chaine-arrow-3-activite-3',
            'chaine-img-4-activite-3-en',
            'chaine-arrow-4-activite-3',
            'chaine-img-5-activite-3-en',
            'chaine-arrow-5-activite-3',
            'chaine-img-6-activite-3-en',
        ],
        lettres: ['H', 'U', 'M', 'A', 'N', 'S'],
        lettresPositions: {
            center: [
                { x: 663, y: 330 },
                { x: 663 + 27, y: 330 },
                { x: 663 + 52, y: 330 },
                { x: 663 + 80, y: 330 },
                { x: 663 + 108, y: 330 },
                { x: 663 + 132, y: 330 },
            ],
            bottom: [
                { x: 1230, y: 580 },
                { x: 1230 + 22, y: 580 },
                { x: 1230 + 44, y: 580 },
                { x: 1230 + 68, y: 580 },
                { x: 1230 + 90, y: 580 },
                { x: 1230 + 112, y: 580 },
            ],
        },
        endTitre: 'Well done !',
        endTexte: `You found the word:`,
        endTexte2: `People are the biggest danger to the ocean food chain...`,
        videoKey: 'rorqualVideo-en',
    },
    {
        lang: 'it',
        imagesChaineAlimentaire: [
            'chaine-img-1-activite-3-it',
            'chaine-arrow-1-activite-3',
            'chaine-img-2-activite-3-it',
            'chaine-arrow-2-activite-3',
            'chaine-img-3-activite-3-it',
            'chaine-arrow-3-activite-3',
            'chaine-img-4-activite-3-it',
            'chaine-arrow-4-activite-3',
            'chaine-img-5-activite-3-it',
            'chaine-arrow-5-activite-3',
            'chaine-img-6-activite-3-it',
        ],
        lettresPositions: {
            center: [
                { x: 663, y: 330 },
                { x: 663 + 27, y: 330 },
                { x: 663 + 52, y: 330 },
                { x: 663 + 80, y: 330 },
                { x: 663 + 108, y: 330 },
                { x: 663 + 132, y: 330 },
            ],
            bottom: [
                { x: 1230, y: 580 },
                { x: 1230 + 22, y: 580 },
                { x: 1230 + 44, y: 580 },
                { x: 1230 + 68, y: 580 },
                { x: 1230 + 90, y: 580 },
                { x: 1230 + 112, y: 580 },
            ],
        },
    },
    {
        lang: 'de',
        imagesChaineAlimentaire: [
            'chaine-img-1-activite-3-de',
            'chaine-arrow-1-activite-3',
            'chaine-img-2-activite-3-de',
            'chaine-arrow-2-activite-3',
            'chaine-img-3-activite-3-de',
            'chaine-arrow-3-activite-3',
            'chaine-img-4-activite-3-de',
            'chaine-arrow-4-activite-3',
            'chaine-img-5-activite-3-de',
            'chaine-arrow-5-activite-3',
            'chaine-img-6-activite-3-de',
        ],
        lettresPositions: {
            center: [
                { x: 663, y: 330 },
                { x: 663 + 27, y: 330 },
                { x: 663 + 52, y: 330 },
                { x: 663 + 80, y: 330 },
                { x: 663 + 108, y: 330 },
                { x: 663 + 132, y: 330 },
            ],
            bottom: [
                { x: 1230, y: 580 },
                { x: 1230 + 22, y: 580 },
                { x: 1230 + 44, y: 580 },
                { x: 1230 + 68, y: 580 },
                { x: 1230 + 90, y: 580 },
                { x: 1230 + 112, y: 580 },
            ],
        },
    },
    {
        lang: 'pol',
        imagesChaineAlimentaire: [
            'chaine-img-1-activite-3-pol',
            'chaine-arrow-1-activite-3',
            'chaine-img-2-activite-3-pol',
            'chaine-arrow-2-activite-3',
            'chaine-img-3-activite-3-pol',
            'chaine-arrow-3-activite-3',
            'chaine-img-4-activite-3-pol',
            'chaine-arrow-4-activite-3',
            'chaine-img-5-activite-3-pol',
            'chaine-arrow-5-activite-3',
            'chaine-img-6-activite-3-pol',
        ],
        lettresPositions: {
            center: [
                { x: 663, y: 330 },
                { x: 663 + 27, y: 330 },
                { x: 663 + 52, y: 330 },
                { x: 663 + 80, y: 330 },
                { x: 663 + 108, y: 330 },
                { x: 663 + 132, y: 330 },
            ],
            bottom: [
                { x: 1230, y: 580 },
                { x: 1230 + 22, y: 580 },
                { x: 1230 + 44, y: 580 },
                { x: 1230 + 68, y: 580 },
                { x: 1230 + 90, y: 580 },
                { x: 1230 + 112, y: 580 },
            ],
        },
    },
    {
        lang: 'es',
        imagesChaineAlimentaire: [
            'chaine-img-1-activite-3-es',
            'chaine-arrow-1-activite-3',
            'chaine-img-2-activite-3-es',
            'chaine-arrow-2-activite-3',
            'chaine-img-3-activite-3-es',
            'chaine-arrow-3-activite-3',
            'chaine-img-4-activite-3-es',
            'chaine-arrow-4-activite-3',
            'chaine-img-5-activite-3-es',
            'chaine-arrow-5-activite-3',
            'chaine-img-6-activite-3-es',
        ],
        lettresPositions: {
            center: [
                { x: 663 + 27, y: 312 },
                { x: 663 + 52, y: 312 },
                { x: 663 + 81, y: 312 },
                { x: 663 + 108, y: 312 },
                { x: 663 + 132, y: 312 },
                { x: 663 + 162, y: 312 },
            ],
            bottom: [
                { x: 1253, y: 563 },
                { x: 1253 + 22, y: 563 },
                { x: 1253 + 44, y: 563 },
                { x: 1253 + 68, y: 563 },
                { x: 1253 + 90, y: 563 },
                { x: 1253 + 112, y: 563 },
            ],
        },
    },
];

export default quimangequiData;
